import React, { useState, useEffect } from 'react';
import { Navbar } from './Navbar';
import { Sidebar } from './Sidebar';
import { BottomNavigation } from './BottomNavigation';
import { OfflineBanner } from '../ui/OfflineBanner';
import { useNetwork } from '../../contexts/NetworkContext';
import { useKeyboardInset } from '../../hooks/use-keyboard-inset';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);
  const { isOffline, pendingOperationsCount } = useNetwork();

  useKeyboardInset();

  const isNetworkOffline = isOffline || pendingOperationsCount > 0;

  useEffect(() => {
    const handleResize = () => {
      const desktop = window.innerWidth >= 1024;
      setIsDesktop(desktop);
      if (desktop) {
        setIsSidebarOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleCloseSidebar = () => {
    setIsSidebarOpen(false);
  };

  const handleToggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="flex h-screen bg-gray-100 dark:bg-gray-900">
      <OfflineBanner />

      {/* Desktop Sidebar - Always visible on lg+ */}
      {isDesktop && (
        <div className="hidden lg:block">
          <Sidebar isOpen={true} onClose={() => {}} />
        </div>
      )}

      {/* Mobile Sidebar - Overlay */}
      {!isDesktop && (
        <Sidebar isOpen={isSidebarOpen} onClose={handleCloseSidebar} />
      )}

      <div className="flex-1 flex flex-col overflow-hidden">
        <Navbar onMenuClick={handleToggleSidebar} />
        <main className={`flex-1 overflow-x-hidden overflow-y-auto bg-gray-100 dark:bg-gray-900 pb-20 lg:pb-0 ${isNetworkOffline ? 'pt-16' : ''}`}>
          <div className="container-responsive">
            {children}
          </div>
        </main>

        {/* Bottom Navigation - Only on mobile */}
        <BottomNavigation />
      </div>
    </div>
  );
};